// extracted by mini-css-extract-plugin
export var active = "_r-8";
export var addWidgetButton = "_r-9";
export var backButton = "_r-1";
export var pageContainer = "_r-2";
export var settingsContent = "_r-0";
export var sideNavContainer = "_r-6";
export var sideNavLink = "_r-7";
export var widgetContainer = "_r-5";
export var widgetSubsectionItem = "_r-3";
export var widgetSubsectionItemContent = "_r-4";